<mat-card *ngIf="angle" class="card-padding">
  <mat-card-subtitle style="margin: 0; padding: 0;">{{ angle }}</mat-card-subtitle>
  <mat-card-content style="width:100%; overflow:auto; resize: both; padding: 0; margin: 0;">
    <a href="{{ getUrl() }}" target="_blank">
      <img
        [src]="image"
        [style.width.px]="this.dynamicImageSet.width"
      />
    </a>
  </mat-card-content>
</mat-card>
